export enum TaskStatus {
    Queued = 'Queued',
    Cancelled = 'Cancelled',
    InProgress = 'InProgress',
    Success = 'Success',
    Error = 'Error'
  }
  